import { translate } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';

var MaxContactAttributes;
(function (MaxContactAttributes) {
    MaxContactAttributes["CHANNEL_KEY"] = "data-channel-key";
    MaxContactAttributes["PRIMARY_COLOUR"] = "data-primary-colour";
    MaxContactAttributes["START_TEXT"] = "data-start-text";
    MaxContactAttributes["THEME"] = "class";
    MaxContactAttributes["ID"] = "id";
})(MaxContactAttributes || (MaxContactAttributes = {}));
var MaxContactService = /** @class */ (function () {
    function MaxContactService(config) {
        this.isLoaded = false;
        this.channelKey = '';
        this.sdkUrl = '';
        this.primaryColour = '';
        this.theme = '';
        this.widgetId = '';
        this.channelKey = config.channelKey;
        this.sdkUrl = config.sdkUrl;
        this.primaryColour = config.primaryColour;
        this.theme = config.theme;
        this.widgetId = config.widgetId;
    }
    MaxContactService.prototype.loadMaxContact = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoaded || !this.channelKey || !this.sdkUrl) {
                            return [2 /*return*/, this.openChat()];
                        }
                        this.appendTag();
                        return [4 /*yield*/, this.appendScript()];
                    case 1:
                        _a.sent();
                        setTimeout(function () {
                            _this.openChat();
                        }, 500);
                        this.isLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    MaxContactService.prototype.appendTag = function () {
        var startText = translate('max-contact.start-text');
        var tag = document.createElement('div');
        tag.setAttribute(MaxContactAttributes.ID, this.widgetId);
        tag.setAttribute(MaxContactAttributes.THEME, this.theme);
        tag.setAttribute(MaxContactAttributes.CHANNEL_KEY, this.channelKey);
        tag.setAttribute(MaxContactAttributes.START_TEXT, startText);
        tag.setAttribute(MaxContactAttributes.PRIMARY_COLOUR, this.primaryColour);
        document.body.appendChild(tag);
    };
    MaxContactService.prototype.appendScript = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.src = _this.sdkUrl;
            script.onload = function () { return resolve(); };
            script.onerror = function () { return reject(); };
            document.body.appendChild(script);
        });
    };
    MaxContactService.prototype.openChat = function () {
        var button = document.getElementsByClassName('max-chat-header')[0];
        if (button) {
            button.click();
        }
    };
    return MaxContactService;
}());

export { MaxContactAttributes, MaxContactService };
